import { combineReducers } from 'redux';

import {
    contractReducer,
    contractStatusReducer,
    legalInformationReducer,
    legalInformationStatusReducer,
    paymentScheduleStatusReducer,
    quotePricingReducer,
    quotePricingStatusReducer,
} from '../../resources/contract';
import { discussionStatusReducer } from '../../resources/discussion';
import { entitiesReducer } from '../../resources/entities';
import { filterReducer } from '../../resources/filters';
import { messageTemplateStatusReducer } from '../../resources/message-template';

export const rootReducer = () => ({
    entities: entitiesReducer,
    displayFilters: filterReducer,
    contract: contractReducer,
    legalInformation: legalInformationReducer,
    quotePricing: quotePricingReducer,
    status: combineReducers({
        discussion: discussionStatusReducer,
        messageTemplate: messageTemplateStatusReducer,
        contract: contractStatusReducer,
        legalInformation: legalInformationStatusReducer,
        quotePricing: quotePricingStatusReducer,
        paymentSchedule: paymentScheduleStatusReducer,
    }),
});
